import PropTypes from 'prop-types';
import React from 'react'

// Components
import {
	EditProfile,
	Logout,
	ViewPrivate,
	ViewPublic
} from './components'


export default class extends React.Component {
    static propTypes = {
		editing_fields: PropTypes.bool.isRequired,
		isSessionUser: PropTypes.bool.isRequired,
		logout: PropTypes.func.isRequired,
		toggleEditFields: PropTypes.func.isRequired,
		user: PropTypes.object.isRequired
	};

    render() {

		let { editing_fields, isSessionUser, logout, toggleEditFields, user, usersMatch } = this.props;

		if( !isSessionUser && !usersMatch ) return null;
		
		return (

			<div id="action-buttons">

				{ !isSessionUser  && <ViewPrivate /> }

				{ !!isSessionUser && <EditProfile toggleEditFields={toggleEditFields} editing_fields={editing_fields} /> }

				{ !!isSessionUser && <ViewPublic user={user} /> }

				{ !!isSessionUser && <Logout logout={logout} /> }

        	</div>

		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Profile/components/ActionButtons/index.jsx